import { useQueryClient } from '@tanstack/react-query';
import { components } from 'src/generated/v1';
import { $api } from './api';

export type ForecastPlanningSettings = components['schemas']['ForecastPlanningSettings'];
export type ForecastPlanningSettingsUpdate = components['schemas']['ForecastPlanningSettingsUpdate'];

export const useForecastPlanningSettingsQuery = () => {
  return $api.useQuery('get', '/settings/forecast');
};

export const useForecastPlanningSettingsUpdate = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('put', '/settings/forecast', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/settings/forecast'] });
    },
  });
};
